import { UserPermissionsResponse } from '../../Model/responseDtos/UserPermissionsResponse';
import { UserResponse } from '../../Model/responseDtos/UserResponse';
import { ExecuteEndpoint } from '../../components/common/BaseApiService';

export class CurrentUserService {
  public async getCurrentUser(): Promise<UserResponse> {
    return ExecuteEndpoint('current-user', 'GET');
  }

  public async getUserPermissions(): Promise<UserPermissionsResponse> {
    return ExecuteEndpoint('current-user/permissions', 'GET');
  }
}
